/* eslint-disable import/prefer-default-export */
export const selectDynamicPage = (pageList, id) => pageList.filter(page => page.id === id)?.[0]
export const selectMarkdownText = (dynamicPage, language) => dynamicPage?.markdown?.filter(markdown => markdown.lang === language)?.[0]?.text
